export default __webpack_public_path__ + "static/media/login-logo.b906a3ac.png";